import { Link, useLocation } from 'react-router-dom';

const toTitle = (slug: string) => slug
  .replace(/-/g, ' ')
  .replace(/\b\w/g, (m) => m.toUpperCase());

const Breadcrumbs = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const crumbs = segments.map((seg, idx) => {
    const path = '/' + segments.slice(0, idx + 1).join('/');
    const isLast = idx === segments.length - 1;
    return { label: toTitle(seg), path, isLast };
  });

  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb">
      <ol className="breadcrumb flex items-center text-sm text-secondary">
        <li>
          <Link to="/" className="hover:text-primary">Home</Link>
        </li>
        {crumbs.map((c, i) => (
          <li key={c.path} className="flex items-center">
            <span className="mx-2 text-secondary">/</span>
            {c.isLast ? (
              <span className="text-primary-dark font-medium" aria-current="page">{c.label}</span>
            ) : (
              <Link to={c.path} className="hover:text-primary">{c.label}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
